// @flow

import { isLocalHoustonLocation, isSeekLocation } from '@seek/seek-jobs-seo';

export const getDefaultLinkTargetFromLocation = (
  location: UrlLocation
): string | null => {
  // if this is a placeholder or this is a relative path
  if (!location.href || !location.hostname) {
    return null;
  }

  // if this is within the seek domain
  if (isSeekLocation(location)) {
    return '_self';
  }

  return '_blank';
};

export const shouldOpenLinkExternally = (
  location: UrlLocation,
  windowLocation: UrlLocation
): boolean => {
  return !isLocalHoustonLocation(location, windowLocation);
};
